export { Theme } from './antd';
export type { ThemeProps } from './antd';
